export const MittwaldAPIClientVersion = '4.175.0';